
import React, { use, useState , useEffect} from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Row, Col, Button, Card } from "react-bootstrap";

import { FaAngleLeft } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

import {useLoading} from '../../components/LoadingProvider';


import { getPlantById } from "../../services/plants/publicPlantsService";

const PlantDetailsPage = () => {
  const { id } = useParams(); // plant Id
  const navigate = useNavigate();
  const { showLoading, hideLoading, toast } = useLoading();

  const [plant,setPlant] = useState(null);
  const [isLoggedIn,setIsLoggedIn] = useState(false);

  const BASE_URL = process.env.REACT_APP_BASE_URL;
  
useEffect(() => {

  showLoading();

  getPlantById(id)
    .then(d => {
      const data = d.data;
      const isLoggedIn = d.isloggedIn;
      setIsLoggedIn(isLoggedIn);
      console.log(isLoggedIn,data)

      setPlant(
         {
        id: data._id,
        name: data.name,
        latinName: data.latinName,
        description: data.description,
        images: (data.images || []).map(img=>({
          url : BASE_URL + img.url
        })),
        aparatEmbedUrl: data.aparatEmbedUrl,
        // watering: [
        //   {
        //   frequency: "هر ۷ روز یکبار",
        //   tips: "در زمستان فواصل آبیاری بیشتر شود. خاک باید قبل از آبیاری خشک شده باشد."
        // }
        // ]
      });


    })
    .catch(err => {
        console.log('ERROR ::: ',err)
        toast.error('Error on loading Plant!')

        setTimeout(() => {
          navigate('/plants?error=plant-error')
        }, 1000);
    })
    .finally(() => {
      hideLoading()

    });




}, [id]);


  const { t } = useTranslation();

  const handleBack = () => {
    navigate(-1); // یا مسیر خاص مثل: navigate('/groups');
  };
 

   if(!plant)
    {
      return (<div>loading...</div>);
    }

  return (


   

    <Container className="my-4">
        


 <div className="d-flex justify-content-between align-items-center mb-4">
      <h2 className="mb-0">{t('botany.plantTitle')}</h2>
      <button className="btn btn-outline-secondary rounded-pill px-3" onClick={handleBack}>
        <FaAngleLeft/>
         {t('common.back')}
      </button>
    </div>


      <h2 className="mb-3 text-center">{plant.name}</h2>



      {/* گالری تصاویر */}
      <Row className="mb-4">
        {plant.images.map((img, idx) => (
          <Col xs={6} md={4} key={idx} className="mb-3">
            <Card className="shadow-sm">
              <Card.Img variant="top" src={img.url} alt={`plant-${idx}`} 
              style={{ objectFit: "cover", height: "200px" }} />
            </Card>
          </Col>
        ))}
      </Row>

      <p className="text-muted ">{plant.description}</p>

      {/* اطلاعات آبیاری */}
{/* 
        {plant && plant.watering.map(w=>{
            <Card className="mb-4 bg-light shadow-sm">
                  <Card.Body>
                    <Card.Title className="text-success">زمان‌بندی آبیاری</Card.Title>
                    <Card.Text>
                      <strong>دفعات آبیاری:</strong> {w.frequency}
                      <br />
                      <strong>نکات:</strong> {w.tips}
                    </Card.Text>
                  </Card.Body>
                </Card>


        })} */}

    

      {/* دکمه‌ی یادآور */}
      <div className="text-center">
        {
          isLoggedIn 
          ? 
              <Button
          variant="success"
          size="lg"
          className="rounded-pill px-4"
          onClick={() => navigate(`/reminders/add/${plant.id}`)}
        >
          فعال‌سازی یادآور برای این گیاه
        </Button>
          :
              <Button
                variant="danger"
                size="lg"
                className="rounded-pill px-4"
                onClick={() => navigate(`/login?return=/reminders/add/${plant.id}`)}
              >
                فعال‌سازی یادآور برای این گیاه
              </Button>
        }
    
      </div>
    </Container>
  );
};

export default PlantDetailsPage;
